import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Box} from '@tenancy.nz/ui';
import {StyledConfettiImage} from './confetti-text.styled';
import confetti from '../assets/confetti.gif';

function ConfettiText({children, loop = false}) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loop === false) {
        setShow(false);
      }
    }, 4000);
    return () => clearTimeout(timeout);
  }, [loop]);

  return (
    <Box position="relative" overflow="hidden">
      {show && <StyledConfettiImage src={confetti} alt="Confetti" />}
      <Box position="relative" zIndex="2">
        {children}
      </Box>
    </Box>
  );
}

ConfettiText.propTypes = {
  children: PropTypes.node.isRequired,
  loop: PropTypes.bool,
};

ConfettiText.defaultProps = {
  loop: false,
};

export default ConfettiText;
